module.exports = "/images/light.svg?e328735f218bb33d0760ce8c8e43fd8a";